import { render, staticRenderFns } from "./Taobao-report.vue?vue&type=template&id=56b806b4&"
import script from "./Taobao-report.vue?vue&type=script&lang=js&"
export * from "./Taobao-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports